export default "__VITE_ASSET__BvwshHFE__"